module.exports = __webpack_public_path__ + "img/LOGO_GIF.a4f349b0.gif";